module.exports = __webpack_public_path__ + "assets/TEquilateralDetailed.291b44032c73ce226b280c4230aee8ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TEquilateralDetailed.png
// module id = 578
// module chunks = 0